import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '../../../services';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FileUploadService extends ApiService {

  constructor(http: HttpClient) {
    super(http, 'Document');
  }

  override save<FormData>(data: FormData) {
    if(data == null) return of([])
    return this.http.post<any>(`${this.route()}/Upload`, data);
  }

  deleteFile(documentID: string) {
    if (!documentID?.trim()) return of(null);
    return this.http.delete<any>(`${this.route()}/${documentID}`);
  }

  downloadFile(name: string) {
    const normalizedPath = name
      ?.split('/')
      .map((segment) => encodeURIComponent(segment))
      .join('/');
    return this.http.get(`${this.route()}/download/${normalizedPath}`, { responseType: 'blob' });
  }

  getDownloadRequest(doc: { documentPath?: string; documentName?: string }): Observable<Blob> {
    const documentPath = doc?.documentPath?.trim();
    if (documentPath) return this.downloadFile(documentPath);
    if ((doc?.documentName as string)?.trim()) return this.downloadFile(doc.documentName as string);
    return of(new Blob());
  }
}
